



import { Vue, Prop, Watch, Component } from "vue-property-decorator";

@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue {

    constructor() {
        super();

    }

    @Prop()
    public Mensaje: string;

    @Watch( 'Mensaje', { immediate: true } )
    onMensaje() {
        this.Abierto = true;
    }

    @Prop()
    public Tipo: string;

    public Abierto: boolean = false;

    mounted() {

        setInterval( () => {
            this.Abierto = false;
        }, 3000 );


    }

}
